import React from 'react';
import { Hint, Text } from 'components';
import { typography } from 'constants/styles';
import { Intent } from 'constants/ui';
const CannotUpdateFieldHint = () => (React.createElement(Hint, { className: "margin-bottom--large", intent: Intent.WARNING },
    React.createElement(Text.Semibold, { color: typography.TextColor.YELLOW_DARK, size: typography.TextSize.LEVEL_200 }, "You can't update these fields at this time.")));
export default CannotUpdateFieldHint;
